import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class ThirdPartySource extends Resource {
    public override type = 'thirdPartySources';

    @prop()
    @required()
    public name!: string;

}